module.exports = __webpack_public_path__ + "img/tendencys.c4b4c9d6.svg";